import React, { useEffect, useRef, useState } from "react";
import authService from "../Auth/AuthService";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { Verified } from "@mui/icons-material";
import FeesentryForm from "../view-form/FeesentryForm";
import ModalView from "../model/ModelView";

function FeesentryView({ classRoom, masterId, handleCloseFee }) {
  const [fees, setFees] = useState([]);
  const [feesEntry, setFeesEntry] = useState(null);
  const [feesForm, setFeesForm] = useState(false);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    loadFees();
  }, []);

  const loadFees = async () => {
    try {
      const url = authService.pathUrl('GET', '/fees/student/')
      const res = await authService.getAuth(url + `${classRoom.studentId}`)
      if (res.length === 0) {
        handleCloseFee(true);
      }
      setFees(res);
    } catch (error) {

    }
  }

  const handleClose = () => {
    setFeesForm(false);
  };

  const handlePay = (id, amount) => {
    const payload = {
      studentId: classRoom?.studentId || "",
      classId: classRoom?.classId || "",
      standard: classRoom?.standard || "",
      annualfee: classRoom?.annualfee || "",
      paidAmount: amount,
    }
    setFeesEntry(payload);
    // setFees(fees.map(fee => (fee.id === id ? res.data : fee)));
    // });
    setFeesForm(true);
  };

  return (
    <Box sx={{ mb: 1 }} >
      <Table size="small">
        <TableHead>
          <TableRow sx={{ background: "#b9d8f7ff" }}>
            <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Last Pay Date</TableCell>
            <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Annual Fees</TableCell>
            <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Paid</TableCell>
            <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Status</TableCell>
            {/* <TableCell>Due Date</TableCell> */}
            <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Pay</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fees.map((m) => (
            <TableRow key={m.id}>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{m.paymentDate}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{m.annualFees}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{m.paidAmount}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{m.status}</TableCell>
              {/* <TableCell>{m.dueDate}</TableCell> */}
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>
                {m.status !== "Paid" ? (
                  <button
                    onClick={() => {
                      const pay = m.annualFees - fees.reduce((sum, fee) => sum + Number(fee.paidAmount || 0), 0);
                      handlePay(m.id, pay);
                    }}
                  >Pay ₹ {m.annualFees - fees.reduce((sum, fee) => sum + Number(fee.paidAmount || 0), 0)}</button>
                ) : (
                  <Verified color="secondary" />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <ModalView size={'sm'}
        open={feesForm}
        handleClose={handleClose}
        title="Fees Entry"
        content={<FeesentryForm
          classRoom={feesEntry}
          masterId={masterId}
          onSuccess={() => {
            setFeesForm(false);
          }}
        />}
      />
    </Box>
  );
}

export default FeesentryView;
